import React, { useState } from "react";
import { TouchableOpacity, Text, StyleSheet, View } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";

interface NoDataFoundProps {
  marginTop?: number;
  color?: string;
  flex?: number;
  textAlign?: string;
  text?: string;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  marginTop = 10,
  color = AppColors.white,
  flex = 1,
  textAlign,
  text = "No Record Found",
}) => {
  return (
    <Text
      style={[
        AppFontStyle.REGULAR_ANYBODY_14,
        {
          color: color,
          flex: flex,
          alignSelf: "center",
          marginTop: marginTop,
          textAlign: "center",
        },
      ]}
    >
      {text}
    </Text>
  );
};

export default NoDataFound;
